import dayjs from 'dayjs';
import { Formik } from 'formik';
import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AddPersonSchema } from '../components/AddPersonModal';
import InputFormik from '../components/formik/InputFormik';
import Breadcrumbs from '../components/ui/Breadcrumbs';
import Button from '../components/ui/Button';
import { usePersonMutation } from '../hooks/usePersonMutation';
import { usePersons } from '../hooks/usePersons';

const EditPersonPage = () => {
  const params = useParams();
  const navigate = useNavigate();
  const query = usePersons({ refetchOnMount: false, refetchOnWindowFocus: false });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const person = useMemo(() => query.data?.find((p) => p.id === params.personId), [query.data]);

  const mutation = usePersonMutation({
    onSuccess: () => {
      navigate(`/ideas/${params.personId}`);
    },
  });

  return (
    <div style={{ margin: '2rem' }} className="space-y-4">
      <Breadcrumbs
        crumbs={[
          { text: 'Ideen', route: '/ideas' },
          { text: person?.name || 'Person', route: '/ideas/' + params.personId },
          { text: 'Bearbeiten', route: `/ideas/${params.personId}/edit` },
        ]}
      />
      <h1 className="text-white text-xl">
        <b>{person?.name ? `"${person.name}"` : 'Person'} bearbeiten</b>
      </h1>
      {person && (
        <Formik
          initialValues={{
            name: person.name,
            dateOfBirth: person.dateOfBirth ? dayjs(person.dateOfBirth).format('DD.MM.YYYY') : '',
          }}
          onSubmit={(values) => {
            mutation.mutate({
              personId: params.personId || '',
              name: values.name,
              dateOfBirth: values.dateOfBirth ? dayjs(values.dateOfBirth, 'DD.MM.YYYY').toISOString() : undefined,
            });
          }}
          validationSchema={AddPersonSchema}
        >
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <div className="space-y-4">
                <InputFormik name="name" label="Name *" isRequired placeholder="Name der Person" />
                <InputFormik name="dateOfBirth" label="Geburtstag" placeholder="DD.MM.YYYY" />
                <span className="mb-1" />
                <Button type="submit" isLoading={mutation.isLoading}>
                  Person bearbeiten
                </Button>
              </div>
            </form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default EditPersonPage;
